export default {
  "fillInfo": "あなたの情報を教えてください",
  "welcome": "ようこそ！",
  "subWelcome": "ぼくのひみつきち ",
  "noResult": "結果が見つかりません",
  "changePassword": {
    "title": "新しいパスワードを入力してください",
  },
  "forgotPassword": {
    "sendMail": "We will send an email to reset your password.\n" +
      "Please tab on button in that mail."
  },
  "resetPassWordSuccess": {
    "before": " 登録したメールアドレスを入力して送信ボタンをタップしてください。",
    "after" : "to reset password "
  },
  "tutorialMessage": {
    "start": {
      "title": "お子様の成長をサポートしやすい環境を作るため、発達のできている項目にチェックをしていきましょう！",
      "content": "専門的な観点から0歳～5歳までのお子様を対象に成長の流れを確認することができ、月齢を参考に、お子様の身体的・精神的な成長のサポート方法をテキストや動画で確認したりすることができます。"
    },
    "finish": {
      "title": "お子様の成長の記録ができましたね！",
      "content": "これからの成長のステップ\n" +
          "をマイページで確認してみましょう！"
    },
    "header": "カテゴリの説明部分です。カテゴリの説明部分です。カテゴリの説明部分です。"
  },
  "addNewBaby": "お子様の情報を教えてください",
  "changeUserInfo": {
    "yourInformation": "会員情報",
    "updatePassword": "パスワードを変更",
    "babyInformation": {
      "before": "Baby",
      "after": "Information"
    }

  },
  "deleteBaby": "子供の情報を削除する",
  "loginFailure": "メールまたはパスワードが正しくありません",
  "dataInvalid": "形式が無効です",
  'resetPasswordTokenInvalid': 'パスワード再発行に失敗しました',
  'changePasswordFailure': 'パスワード再発行に失敗しました'
};
